import { useMemo, useState } from "react";
import { defaultFilter } from "@/stores/useSearchStore";
import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import isEqual from "lodash.isequal";
import { useTranslation } from "react-i18next";

import { SearchParams } from "@/hooks/api/search/useInfiniteSearch";
import Button from "@/components/atoms/Button";
import Modal from "@/components/molecules/Modal";
import CreateDynamicListModal from "@/components/molecules/modals/CreateDynamicListModal";

type Props = {
  filter: SearchParams;
  changedCompanies: CompanyEntryDto[];
};

const MakeDynamicListFromSearch = ({ filter, changedCompanies }: Props) => {
  const { t } = useTranslation();
  const [isOpened, setIsOpened] = useState(false);

  const isDirty = useMemo(() => {
    return !isEqual(filter, defaultFilter);
  }, [filter]);

  return (
    <>
      <Button
        label={t("dynamic.saveSearch")}
        onClick={() => setIsOpened(true)}
        className={"w-full"}
        color={"brand"}
        variants={"outline"}
        type={"button"}
        disabled={!isDirty}
      />
      <Modal
        isOpen={isOpened}
        onClose={() => setIsOpened(false)}
        content={CreateDynamicListModal}
        contentProps={{
          filter,
          changedCompanies,
          onSuccess: () => setIsOpened(false),
        }}
      />
    </>
  );
};

export default MakeDynamicListFromSearch;
